import React, { useEffect } from 'react';
import '../../css/modals/CloseInscriptions.css';
import { IoClose } from 'react-icons/io5';

import imgPopUp from '../../images/modalHome.jpeg';
import { useState } from 'react';
import { getRemainingTimeUntilMsTimestamp } from '../../utils/countdown';

const CloseInscriptions = () => {
	const [close, setClose] = useState(false);

	const handleCloseModal = (event) => {
		if (event.target.className === 'Inscriptions ') {
			setClose(true);
		}
	};

	const countdownTimestampMs = 'Thu, 4 Dec 2025 23:59:00 GMT-5';

	const defaultRemainingTime = {
		seconds: '00',
		minutes: '00',
		hours: '00',
		days: '00',
	};

	const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);

	function updateRemainingTime(countdown) {
		setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
	}

	useEffect(() => {
		const intervalId = setInterval(() => {
			updateRemainingTime(countdownTimestampMs);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [countdownTimestampMs]);

	return (
		<div className={`Inscriptions ${close ? 'close' : ''}`} onClick={handleCloseModal}>
			<div className={`Inscriptions-content ${close ? 'close' : ''}`}>
				<button
					className='Inscriptions-close-btn'
					onClick={() => {
						setClose(true);
					}}
				>
					<IoClose />
				</button>
				<a id='pop-up-home' href='https://www.libel.academy/master'>
					<img src={imgPopUp} alt='close-inscriptions' />
				</a>

				{/* <a id='pop-up-home' className='btn-camb' href='https://libel.academy/taller'>
					<span>Inscríbete Ahora</span>
				</a> */}

				{/* <div className='cnt-countdown'>
					<div className='membership-countdown'>
						<h5 className='membership-countdown-title'>Oferta termina 2 de abril</h5>
						<div className='membership-countdown-counter'>
							<div className='membership-countdown-counter-item'>
								<p>{remainingTime.days}</p>
								<span>Días</span>
							</div>
							<div className='membership-countdown-counter-item'>
								<p>{remainingTime.hours}</p>
								<span>Horas</span>
							</div>
							<div className='membership-countdown-counter-item'>
								<p>{remainingTime.minutes}</p>
								<span>Min</span>
							</div>
							<div className='membership-countdown-counter-item'>
								<p>{remainingTime.seconds}</p>
								<span>Seg</span>
							</div>
						</div>
					</div>
				</div> */}
			</div>
		</div>
	);
};

export default CloseInscriptions;
